import { Box, Button } from "@mui/material";
import { IAPIConfig, useApi } from "../../custom_hooks/useApi";
import { useState } from "react";
import BOHeader from "../../organisms/Login/BOHeader";
import BusinessDetails from "../../organisms/Login/BusinessDetails";
import ConnectGoogleAccount from "../../organisms/Login/ConnectGoogleAccount";
import CustomToast from "../../utils/cutomToast/CustomToast";
import Loader from "../../utils/loader/Loader";
import ProductsTable from "../../Pages/businessProfile/ProductsTable";
import { urlConstants } from "../../components/constants/globalConstants";
import { useBusinessProfileApis } from "../../custom_hooks/useBusinessProfileApis";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthenticationAfterLogin = () => {
  const { GetBusinessProfilesData } = useBusinessProfileApis();
  const [step, setStep] = useState<
    "businessDetails" | "offerings" | "connectGoogle"
  >("businessDetails");
  const [loading, setLoading] = useState(false);
  const { doApi } = useApi();
  const { userDetails } = useSelector((state: any) => state.auth);
  const steps = ["Business Details", "Offerings"];
  const navigate = useNavigate();
  const [currentBusinessProfile, setCurrentBusinessProfile] =
    useState<any>(null);

  const [businessDataDetails, setBusinessDataDetails] = useState({
    Website: "",
    Name: "",
    PrimaryLocation: {
      Location: "",
      Country: "",
    },
    Category: "",
    Description: "",
    LocationType: "",
    BusinessObjective: "",
    BusinessModel: "",
    CustomerPersonas: [],
    Competitors: [],
    Locations: [],
    ProductsServices: [],
  });
  const handleGoBack = () => {
    if (step === "businessDetails") navigate("/home");
    if (step === "offerings") return;
  };
  const handleContinue = async () => {
    if (step === "businessDetails") {
      if (
        businessDataDetails.Website.trim() === "" ||
        businessDataDetails.Name.trim() === "" ||
        businessDataDetails.PrimaryLocation.Location.trim() === "" ||
        businessDataDetails.PrimaryLocation.Country.trim() === "" ||
        businessDataDetails.BusinessObjective.trim() === "" ||
        businessDataDetails.LocationType.trim() === ""
      ) {
        CustomToast("Please enter all fields", "error");
        return;
      }
      if (await createAgencyBusiness()) {
        setStep("offerings");
      }
    }
    if (step === "offerings") {
      setStep("connectGoogle");
    }
  };

  const handleSkipForNow = () => {
    if (step === "connectGoogle") {
      navigate("/home");
    }
    if (step === "offerings") {
      setStep("connectGoogle");
    }
  };

  const ConnectGoogle = () => {
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?scope=openid%20profile%20email https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/webmasters.readonly https://www.googleapis.com/auth/webmasters https://www.googleapis.com/auth/analytics.readonly https://www.googleapis.com/auth/userinfo.email&prompt=consent&access_type=offline&include_granted_scopes=true&response_type=code&state=state_parameter_passthrough_value&redirect_uri=${urlConstants.ENV_URL}/signin-google&flowName=GeneralOAuthFlow&client_id=${urlConstants.CLIENT_ID}`;
  };

  const createAgencyBusiness = async () => {
    try {
      setLoading(true);

      const payload = {
        userUniqueId: userDetails.uniqueId || "",
        accountUniqueId: "",
        businesses: [
          {
            name: businessDataDetails?.Name,
            description: "",
            website: businessDataDetails?.Website,
            displayName: businessDataDetails?.Name,
            locationType: businessDataDetails?.LocationType,
            propertyId: "",
            category: "",
            brandVoice: "",
            businessModel: "",
            productsServices: [],
            locations: null,
            customerPersonas: null,
            sellingPoints: null,
            businessObjective: businessDataDetails?.BusinessObjective,
            competitors: null,
            uniqueId: "",
            primaryLocation: businessDataDetails?.PrimaryLocation,
            userUniqueId: userDetails.uniqueId || "",
          },
        ],
      };

      const config: IAPIConfig = {
        URL: `/Profile/CreateAgencyBusinesses`,
        method: "POST",
        payLoad: payload,
      };

      const res: any = await doApi(config, "seedcore");

      if (res.status === 200) {
        const updatedProfiles = await GetBusinessProfilesData();
        const finalUpdatedProfiles = JSON.parse(updatedProfiles.data);
        const websiteInput = businessDataDetails.Website.toLowerCase().trim();

        const matchedProfile = finalUpdatedProfiles.find((profile: any) => {
          const profileWebsite = profile.Website?.toLowerCase().trim() || "";
          return (
            profileWebsite.includes(websiteInput) ||
            websiteInput.includes(profileWebsite)
          );
        });
        setCurrentBusinessProfile(matchedProfile || null);

        CustomToast("Businesses connected successfully", "success");
        return true;
      } else {
        CustomToast("Failed to connect businesses", "error");
        return false;
      }
    } catch (error) {
      CustomToast("An error occurred. Please try again.", "error");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Loader spinning={loading}>
      <Box
        sx={{
          bgcolor: "surface.primary",
          color: "text.primary",
          padding: "0px var(--9, 72px)",
          height: "100vh",
          maxWidth: "1300px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "90vh",
            overflowY: "auto", 
            padding: 3,
          }}
        >
          {(step === "businessDetails" || step === "offerings") && (
            <Box>
              <BOHeader
                title={
                  step === "offerings"
                    ? "Add Offerings"
                    : "Add Business Details"
                }
                subTitle={
                  step === "offerings"
                    ? "Input your client's offerings or services here."
                    : "Input your client's details here."
                }
                activeStep={step === "offerings" ? 1 : 0}
                steps={steps}
              />

              {step === "offerings" ? (
                <ProductsTable
                  currentBusinessProfile={currentBusinessProfile}
                />
              ) : (
                <BusinessDetails
                  businessDataDetails={businessDataDetails}
                  setBusinessDataDetails={setBusinessDataDetails}
                />
              )}

              <Box
                display={"flex"}
                gap={1}
                alignItems={"center"}
                marginTop={5}
                sx={{
                  justifyContent:
                    step === "offerings" ? "space-between" : "flex-end",
                }}
              >
                {step === "offerings" && (
                  <Button
                    sx={{
                      textDecoration: "underline",
                      padding: "0 !important",
                    }}
                    variant="text"
                    onClick={handleSkipForNow}
                    size="large"
                    disableRipple
                    color="primary"
                  >
                    Skip for now
                  </Button>
                )}
                <Box sx={{ display: "flex", gap: "8px" }}>
                  {step !== "offerings" && (
                    <Button
                      onClick={handleGoBack}
                      variant="text"
                      size="large"
                      color="primary"
                    >
                      Go Back
                    </Button>
                  )}
                  <Button
                    onClick={handleContinue}
                    variant="contained"
                    size="large"
                    color="primary"
                  >
                    {step === "businessDetails"
                      ? "Continue"
                      : "Continue to Dashboard"}
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
          {step === "connectGoogle" && (
            <ConnectGoogleAccount
              handleConnectToGoogle={ConnectGoogle}
              handleSkinConnectToGoogle={handleSkipForNow}
              handleFailure={() => {
                CustomToast("Google Login Failed", "error");
              }}
            />
          )}
        </Box>
      </Box>
    </Loader>
  );
};

export default AuthenticationAfterLogin;
